import styled from '@emotion/styled/macro';
import { forTabletPortraitDown, GuarantorBadge, Variables } from '@enter/core';
import { Icon } from '@mdi/react';

export const StyledRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin: 12px 0 0 0;
`;

export const StyledCol = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    margin: 12px 0 0 0;

    &:first-of-type {
        align-items: flex-start;
    }
    &:last-of-type {
        align-items: flex-end;
    }

    ${forTabletPortraitDown(`
        flex: 1 1;
    `)}
`;

export const Spacer = styled.span`
    flex-grow: 1;
`;

export const GuarantorInfo = styled.div`
    display: inline-flex;
    align-items: center;
    margin-right: 24px;
    margin-bottom: 12px;
`;

export const GuarantorName = styled.div`
    font-size: 18px;
    color: ${Variables.Colors.p500};
    margin-right: 24px;
    margin-bottom: 12px;
`;

export const GuarantorAmount = styled.div`
    font-size: 24px;
    font-weight: 500;
    color: ${Variables.Colors.p500};
`;

export const GuarantorIcon = styled(Icon)`
    height: 18px;
    width: 18px;
    border-radius: 18px;
    fill: ${Variables.Colors.white};
    background-color: ${Variables.Colors.n85};
    margin-right: 8px;
    padding: 1px 0 2px 0;
`;

export const ActionBadge = styled(GuarantorBadge)`
    margin-top: 12px;
`;
